import { hydraUiApi, useHydraUIAPIQuery } from '@/services/api';
import { SESSION_METADATA_REFETCH_INTERVAL } from '@/features/account-switcher/constants';

/**
 * useAccountMemberships returns the accounts the current login belongs to.
 *
 * The endpoint is not flag-gated — it lists every account_users row, which a
 * backfilled login can have for multiple accounts even while decoupled access is
 * off. So membership count is NOT a capability signal on its own; the switcher
 * gates the account list on the decouple_users feature flag
 * (auth.account.feature_flags) as well — the same flag the backend uses to honor
 * the X-Active-Account-Id header.
 */
export function useAccountMemberships() {
  return useHydraUIAPIQuery({
    queryKey: ['getMemberships', {}],
    queryFn: ({ signal }) => hydraUiApi.memberships.list({ signal }),
    queryConfig: {
      refetchInterval: SESSION_METADATA_REFETCH_INTERVAL,
      refetchOnMount: 'always',
      refetchOnWindowFocus: 'always',
    },
  });
}
